import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '@store';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ViassistAuthGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authStore.state$.pipe(
      filter((state) => state.authenticated && state.authorized),
      mergeMap(() => this.authStore.isEndUser$),
      map((isEndUser) => {
        if (isEndUser) {
          this.router.navigate(['/installations']);

          return false;
        }

        return true;
      })
    );
  }
}
